import { version } from '../../package.json';
import { useForm } from '@/composables/useForm';
import * as amplitude from '@amplitude/analytics-browser';

const { serialize } = useForm();

export function generateDefaultEventProps(target) {
  let props = {
    CurrentUrl: window.location.href
  };

  if (target) {
    let text = '';
    let value = target.value;

    if (target.tagName !== 'FORM') {
      let tmp = document.createElement('DIV');

      if (target.innerHTML) {
        tmp.innerHTML = target.innerHTML.trim();
      }

      if (target.hasAttribute('disable-value-track')) {
        value = null;
      }

      text = tmp.textContent || tmp.innerText || '';
    } else {
      let tmpForm = target.cloneNode(true);
      const elementForRemove = tmpForm.querySelectorAll('input[disable-value-track]');
      if (elementForRemove && elementForRemove.length) {
        for (let index = 0; index < elementForRemove.length; index++) {
          const element = elementForRemove[index];
          element.remove();
        }
      }
      const formData = new FormData(tmpForm);
      value = serialize(formData);
    }

    const inlineAttribute = target.getAttribute('amplitude-attribute');

    let parsedInlineAttribute = {};

    if (inlineAttribute && inlineAttribute.length) {
      parsedInlineAttribute = JSON.parse(inlineAttribute);
    }

    props = {
      ...props,
      ...parsedInlineAttribute,
      Id: target.getAttribute('id'),
      Class: target.getAttribute('class'),
      Text: text
    };

    if (value) {
      props = {
        ...props,
        Value: value
      };
    }

    if (target.getAttribute('name')) {
      props['Name'] = target.getAttribute('name');
    }

    if (target.getAttribute('type')) {
      props['Type'] = target.getAttribute('type');
    }
    if (target.getAttribute('type') === 'checkbox') {
      props['Checked'] = target.checked;
    }
  }

  return props;
}

export function onClick(instance, target, props = {}) {
  return log(instance, 'Click', target, props);
}

export function onSubmit(instance, target, props = {}) {
  return log(instance, 'Submit', target, props);
}

export function onChange(instance, target, props = {}) {
  return log(instance, 'Change', target, props);
}
export function onCheck(instance, props = {}) {
  return log(instance, 'Check', null, props);
}
export function onFileUploaded(
  instance,
  file,
  { progress = null, bytesSent = null, referenceMeta = null, ...otherProps } = {}
) {
  const addtionalProps = {
    File: {
      Size: file.size,
      Name: file.name,
      Type: file.type
    },
    Progress: progress,
    BytesSent: bytesSent,
    ReferenceMeta: referenceMeta,
    ...otherProps
  };

  return log(instance, 'FileUploaded', null, addtionalProps);
}

export function onFileRemoved(instance, file, { referenceMeta = null, ...otherProps } = {}) {
  const addtionalProps = {
    File: {
      Size: file.size,
      Name: file.name,
      Type: file.type,
      Url: file.url
    },
    ReferenceMeta: referenceMeta,
    ...otherProps
  };

  return log(instance, 'FileRemoved', null, addtionalProps);
}

export function log(instance, name, target, props = {}) {
  const targetProps = generateDefaultEventProps(target);

  instance.track(name, {
    ...targetProps,
    ...props
  });
}

export const amplitudePlugin = {
  install(Vue, apiKey, branch) {
    const options = {
      appVersion: version,
      defaultTracking: {
        // pageViews: {
        //   trackHistoryChanges: "pathOnly",
        // },
        sessions: true,
        // formInteractions: true,
        fileDownloads: true
      },
      plan: {
        branch: branch
      }
    };

    amplitude.init(apiKey, null, options);

    // amplitude.setOptOut(true); // disable amplitude by default
    Vue.prototype.$amplitudeClient = amplitude;

    Vue.$amplitudeClient = amplitude;

    // Global amplitude event listeners
    document.addEventListener(
      'click',
      function (event) {
        // console.log(
        //   "Is clicked: ",
        //   event.target.matches("li, a, button, *[href]"),
        //   event.target
        // );

        if (
          event.target.matches(
            'li:not([disable-event-track]), a:not([disable-event-track]), button:not([disable-event-track]), *[href]:not([disable-event-track])'
          )
        ) {
          onClick(amplitude, event.target);
        }
      },
      false
    );

    document.addEventListener(
      'submit',
      function (event) {
        // console.log(
        //     "Is submitted: ",
        //     event.target.matches('form')
        // );

        if (
          event.target.matches(
            'form:not([disable-event-track]), *[type="submit"]:not([disable-event-track])'
          )
        ) {
          onSubmit(amplitude, event.target);
        }

        // Log the submitted element in the console
        // console.log(event.target);
      },
      false
    );

    document.addEventListener(
      'change',
      function (event) {
        // console.log(
        //     "Is changed: ",
        //     event.target.matches('input, select, textarea, radio, checkbox')
        // );

        if (
          event.target.matches(
            'input:not([disable-event-track]), select:not([disable-event-track]), textarea:not([disable-event-track]), radio:not([disable-event-track]), checkbox:not([disable-event-track])'
          )
        ) {
          onChange(amplitude, event.target);
        }

        // Log the changed element in the console
        // console.log(event.target);
      },
      false
    );
  }
};

export default amplitudePlugin;
